import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-juridictions',
  templateUrl: './juridictions.component.html',
  styleUrls: ['./juridictions.component.css']
})
export class JuridictionsComponent implements OnInit {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  constructor(
    private formulaireService: FormulaireService,
    public modeRenduService: ModeRenduService,
    public saisieService: SaisieService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.juridictions) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('juridictions', new UntypedFormArray([]));
    }
    if (! this.detailPersonnesRecues) {
      (this.rootForm.get('personnesRecues') as UntypedFormGroup).setControl('detailPersonnesRecues', new UntypedFormArray([]));
    }
    if (! this.lieuxTj) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxTj', new UntypedFormArray([]));
    }
   }

  ngOnInit() {
    this.trierJuridictions();
  }

  get juridictions() {
    return this.rootForm.get('dg').get('juridictions') as UntypedFormArray;
  }

  get detailPersonnesRecues() {
    return this.rootForm.get('personnesRecues').get('detailPersonnesRecues') as UntypedFormArray;
  }

  get lieuxTj() {
    return this.rootForm.get('moyens').get('lieuxTj') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('dg') as UntypedFormGroup;
  }

  public ajouterJuridiction() {
    // on récupère le nombre total avant ajout
    let nbJuridictions = this.formulaire.get('xxTjNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    // Boucle sur les juridictions principales - DG
    this.juridictions.push(new UntypedFormGroup({
      xxTjRang: new UntypedFormControl(this.juridictions.length, Validators.required),
      xxTjIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('xxTjIelst'))
    }));
    // Boucle dépendante sur les juridictions sur les personnes recues 
    this.detailPersonnesRecues.push(new UntypedFormGroup({
      ccTjRang: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjRang')),
      ccTjIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('ccTjIelst')),
      ccTjVifTgdNb: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifTgdNb')),
      ccTjVifTgdSuivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifTgdSuivi')),
      ccTjVifTgdEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifTgdEntret')),
      ccTjVifTgdNbUrge: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifTgdNbUrge')),
      ccTjVifBarNb: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifBarNb')),
      ccTjVifBarSuivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifBarSuivi')),
      ccTjVifBarEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifBarEntret')),
      ccTjVifBarNbUrge: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifBarNbUrge')),
      ccTjVifEvviCpleSais: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviCpleSais')),
      ccTjVifEvviCpleVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviCpleVict')),
      ccTjVifEvviCpleEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviCpleEntret')),
      ccTjVifEvviHcpleSais: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviHcpleSais')),
      ccTjVifEvviHcpleVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviHcpleVict')),
      ccTjVifEvviHcpleEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjVifEvviHcpleEntret')),
      ccTjEvviHvifSais: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjEvviHvifSais')),
      ccTjEvviHvifVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjEvviHvifVict')),
      ccTjEvviHvifEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('ccTjEvviHvifEntret'))
    }));
    // Boucle dépendante sur les juridictions pour les lieux de permanence Tribunal
    this.lieuxTj.push(new UntypedFormGroup({
      aaLieuTjRang: new UntypedFormControl(null,validationsQuestionsDynamiques.get('aaLieuTjRang')),
      aaLieuTjIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuTjIelst')),
      aaLieuTjQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuTjQp')),
      aaLieuTjNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuTjNbPerm')),
      aaLieuTjNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuTjNbPermEtp')),
      aaLieuTjNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuTjNbVict'))
    }));

    this.step = this.juridictions.length - 1 ;
    
    this.saisieService.ajoutValidateurCroisePersonnesRecues(this.detailPersonnesRecues, this.detailPersonnesRecues.length - 1);
    this.saisieService.ajoutValidateurCroiseLieuxTj(this.lieuxTj, this.lieuxTj.length - 1);


    // on incrémente le nombre total de juridictions
    this.formulaire.get('xxTjNb').setValue(++nbJuridictions);
  }

  public supprimerJuridiction(index?: number) {
    if (index >= 0) {
      const juridictionValeur = this.juridictions.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${juridictionValeur['xxTjIelst']} ?`)) {
        this.juridictions.removeAt(index);
        this.detailPersonnesRecues.removeAt(index);
        this.lieuxTj.removeAt(index);
      }
    } else {
      this.juridictions.removeAt(this.juridictions.length - 1);
      this.detailPersonnesRecues.removeAt(this.juridictions.length - 1);
      this.lieuxTj.removeAt(this.juridictions.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de juridictions
    this.formulaire.get('xxTjNb').setValue(this.juridictions.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierJuridictions(): void {
    this.juridictions.controls.sort((a, b) => {
      if (a.get('xxTjRang').value < b.get('xxTjRang').value) {
            return -1;
      } else if (a.get('xxTjRang').value > b.get('xxTjRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.juridictions.length; index++) {
      this.juridictions.controls[index].get('xxTjRang').setValue(index);
    }
    this.trierJuridictions();
  }

  public xxTjIelst(index: number): string {
    let resultat = '';
    if (this.juridictions.controls[index].get('xxTjIelst') !== null) {
      resultat = this.juridictions.controls[index].get('xxTjIelst').value;
    }
    return resultat;
  }

}
